import * as Yup from 'yup';

import { Strings } from '@app/constants';

// ----------------Add Portfolio----------------
export const addPortfolioSchema = Yup.object()
  .shape({
    image: Yup.string().required(Strings.validation.uploadRequired(Strings.field.image)),
    name: Yup.string().trim().required(Strings.validation.fieldRequired(Strings.field.name)),
    category: Yup.string().required(Strings.validation.fieldRequired(Strings.field.category)),
    description: Yup.string().required(Strings.validation.fieldRequired(Strings.field.description)),
    link: Yup.string().required(Strings.validation.fieldRequired(Strings.field.link)),
  })
  .required();
